export const FEEDBACK_SLICE_NAME = 'feedback';

export interface FeedbackSliceState {
  isFeedbackDrawerOpen: boolean;
}
